import { mapState } from 'vuex'
import ROSLIB from 'roslib'

const BELUGA_COMMAND = 146
const BELUGA_PING = 137

const CMD_MONITORING_INTERVALS = 108
const CMD_REPORTING_INTERVALS = 109

// const PRIO_PROCESS = 2
const PRIO_USER = 1
const PRIO_EMERGENCY = 0

const CHANNEL_AUTO = 0
const INTERVALS_REPORTING = 1

export default {
  name: 'MessageFactory',
  data: function () {
    return {
      sequence_id: 0
    }
  },
  computed: {
    ...mapState(['selectedPlatform', 'clientId'])
  },
  methods: {
    getNewSequenceId: function () {
      this.sequence_id = this.sequence_id + 1
      return this.sequence_id
    },
    requestMessage: function (widget, platformId, messageType) {
      const message = new ROSLIB.Message({
        requester: this.clientId,
        destination: platformId,
        sequence_id: this.getNewSequenceId(),
        type: BELUGA_COMMAND,
        payload: '{"command_id": 1, ' +
          '"ints": [' + messageType + ']}',
        priority: PRIO_USER,
        channel: CHANNEL_AUTO,
        is_reply: false
      })
      widget.$root.$emit('sendMessage', message)
      console.log('message factory: platform ' + platformId + ': Request message type ' + messageType)
    },
    sendGoto: function (widget, platformId, latitude, longitude) {
      if (Number(platformId) !== 0) {
        const altitudeConfirm = confirm('Use altitude mode? (Cancel = depth mode)')
        let depthAltitudeMsg = 'Enter depth:'
        let depthAltitudeDefault = '0'
        let altitudeMode = 0
        if (altitudeConfirm) {
          altitudeMode = 1
          depthAltitudeMsg = 'Enter altitude:'
          depthAltitudeDefault = '5'
        }
        const depthAltitude = prompt(depthAltitudeMsg, depthAltitudeDefault)
        if (depthAltitude != null && !isNaN(Number(depthAltitude))) {
          const surge = prompt('Enter surge:', '0.5')
          if (surge != null && !isNaN(Number(surge))) {
            let depth = 0
            let altitude = 0
            if (altitudeMode === 1) {
              // Altitude mode
              altitude = depthAltitude
            } else {
              // Depth mode
              depth = depthAltitude
            }
            const message = new ROSLIB.Message({
              requester: this.clientId,
              destination: platformId,
              sequence_id: this.getNewSequenceId(),
              type: BELUGA_COMMAND,
              payload: '{"command_id": 20, ' +
                        '"latitude_1": ' + latitude + ', ' +
                        '"longitude_1": ' + longitude + ', ' +
                        '"floats": [' + depth + ', ' + altitude + ', ' + surge + ', 2.0], ' +
                        '"ints": [1, ' + altitudeMode + ', 3600], ' +
                        '"bools": [false]}',
              priority: PRIO_USER,
              channel: CHANNEL_AUTO,
              is_reply: false
            })
            widget.$root.$emit('sendMessage', message)
            console.log('message factory: platform ' + platformId + ': Go to position')
          } else {
            alert('Wrong surge value!')
          }
        } else {
          alert('Wrong depth / altitude value!')
        }
      } else {
        alert('No platform selected!')
      }
    },
    sendGotoSurface: function (widget, platformId, latitude, longitude) {
      if (Number(platformId) !== 0) {
        const message = new ROSLIB.Message({
          requester: this.clientId,
          destination: platformId,
          sequence_id: this.getNewSequenceId(),
          type: BELUGA_COMMAND,
          payload: '{"command_id": 20, ' +
                    '"latitude_1": ' + latitude + ', ' +
                    '"longitude_1": ' + longitude + ', ' +
                    '"floats": [' + 0 + ', ' + 0 + ', ' + 0.5 + ', 2.0], ' +
                    '"ints": [1, ' + 0 + ', 3600], ' +
                    '"bools": [false]}',
          priority: PRIO_USER,
          channel: CHANNEL_AUTO,
          is_reply: false
        })
        widget.$root.$emit('sendMessage', message)
        console.log('message factory: platform ' + platformId + ': Go to position (surface)')
      }
    },
    keepPosition: function (widget, platformId) {
      const response = confirm('Are you sure?')
      if (response) {
        const message = new ROSLIB.Message({
          requester: this.clientId,
          destination: platformId,
          sequence_id: this.getNewSequenceId(),
          type: BELUGA_COMMAND,
          payload: '{"command_id": 21}',
          priority: PRIO_USER,
          channel: CHANNEL_AUTO,
          is_reply: false
        })
        widget.$root.$emit('sendMessage', message)
        console.log('message factory: platform ' + platformId + ': Keep position')
      }
    },
    setIdle: function (widget, platformId) {
      const response = confirm('Are you sure?')
      if (response) {
        const message = new ROSLIB.Message({
          requester: this.clientId,
          destination: platformId,
          sequence_id: this.getNewSequenceId(),
          type: BELUGA_COMMAND,
          payload: '{"command_id": 22}',
          priority: PRIO_USER,
          channel: CHANNEL_AUTO,
          is_reply: false
        })
        widget.$root.$emit('sendMessage', message)
        console.log('message factory: platform ' + platformId + ': Set idle')
      }
    },
    enableRanging: function (widget, platformId) {
      const response = confirm('Are you sure?')
      if (response) {
        const message = new ROSLIB.Message({
          requester: this.clientId,
          destination: platformId,
          sequence_id: this.getNewSequenceId(),
          type: BELUGA_COMMAND,
          payload: '{"command_id": 30}',
          priority: PRIO_USER,
          channel: CHANNEL_AUTO,
          is_reply: false
        })
        widget.$root.$emit('sendMessage', message)
        console.log('message factory: platform ' + platformId + ': Enable ranging')
      }
    },
    disableRanging: function (widget, platformId) {
      const response = confirm('Are you sure?')
      if (response) {
        const message = new ROSLIB.Message({
          requester: this.clientId,
          destination: platformId,
          sequence_id: this.getNewSequenceId(),
          type: BELUGA_COMMAND,
          payload: '{"command_id": 31}',
          priority: PRIO_USER,
          channel: CHANNEL_AUTO,
          is_reply: false
        })
        widget.$root.$emit('sendMessage', message)
        console.log('message factory: platform ' + platformId + ': Disable ranging')
      }
    },
    startMission: function (widget, platformId) {
      const response = confirm('Are you sure?')
      if (response) {
        const message = new ROSLIB.Message({
          requester: this.clientId,
          destination: platformId,
          sequence_id: this.getNewSequenceId(),
          type: BELUGA_COMMAND,
          payload: '{"command_id": 14}',
          priority: PRIO_USER,
          channel: CHANNEL_AUTO,
          is_reply: false
        })
        widget.$root.$emit('sendMessage', message)
        console.log('message factory: platform ' + platformId + ': Start mission')
      }
    },
    sendPing: function (widget, platformId) {
      const message = new ROSLIB.Message({
        requester: this.clientId,
        destination: platformId,
        sequence_id: 0,
        type: BELUGA_PING,
        payload: '',
        priority: PRIO_USER,
        channel: CHANNEL_AUTO,
        is_reply: false
      })
      widget.$root.$emit('sendMessage', message)
      console.log('message factory: platform ' + platformId + ': Ping')
    },
    resetTimer: function (widget, platformId) {
      const message = new ROSLIB.Message({
        requester: this.clientId,
        destination: platformId,
        sequence_id: this.getNewSequenceId(),
        type: BELUGA_COMMAND,
        payload: '{"command_id": 15}',
        priority: PRIO_USER,
        channel: CHANNEL_AUTO,
        is_reply: false
      })
      widget.$root.$emit('sendMessage', message)
      console.log('message factory: platform ' + platformId + ': Reset timer')
    },
    enableThruster: function (widget, platformId) {
      const message = new ROSLIB.Message({
        requester: this.clientId,
        destination: platformId,
        sequence_id: this.getNewSequenceId(),
        type: BELUGA_COMMAND,
        payload: '{"command_id": 23}',
        priority: PRIO_USER,
        channel: CHANNEL_AUTO,
        is_reply: false
      })
      widget.$root.$emit('sendMessage', message)
      console.log('message factory: platform ' + platformId + ': Enable thruster')
    },
    disableThruster: function (widget, platformId) {
      const message = new ROSLIB.Message({
        requester: this.clientId,
        destination: platformId,
        sequence_id: this.getNewSequenceId(),
        type: BELUGA_COMMAND,
        payload: '{"command_id": 24}',
        priority: PRIO_USER,
        channel: CHANNEL_AUTO,
        is_reply: false
      })
      widget.$root.$emit('sendMessage', message)
      console.log('message factory: platform ' + platformId + ': Disable thruster')
    },
    abortAndSurface: function (widget, platformId) {
      const response = confirm('Are you sure?')
      if (response) {
        const message = new ROSLIB.Message({
          requester: this.clientId,
          destination: platformId,
          sequence_id: this.getNewSequenceId(),
          type: BELUGA_COMMAND,
          payload: '{"command_id": 11}',
          priority: PRIO_USER,
          channel: CHANNEL_AUTO,
          is_reply: false
        })
        widget.$root.$emit('sendMessage', message)
        console.log('message factory: platform ' + platformId + ': Abort and surface')
      }
    },
    emergencySurface: function (widget, platformId) {
      const response = confirm('Are you sure?')
      if (response) {
        const message = new ROSLIB.Message({
          requester: this.clientId,
          destination: platformId,
          sequence_id: this.getNewSequenceId(),
          type: BELUGA_COMMAND,
          payload: '{"command_id": 12}',
          priority: PRIO_EMERGENCY,
          channel: CHANNEL_AUTO,
          is_reply: false
        })
        widget.$root.$emit('sendMessage', message)
        console.log('message factory: platform ' + platformId + ': Emergency surface')
      }
    },
    cancelEmergencySurface: function (widget, platformId) {
      const response = confirm('Are you sure?')
      if (response) {
        const message = new ROSLIB.Message({
          requester: this.clientId,
          destination: platformId,
          sequence_id: this.getNewSequenceId(),
          type: BELUGA_COMMAND,
          payload: '{"command_id": 19}',
          priority: PRIO_EMERGENCY,
          channel: CHANNEL_AUTO,
          is_reply: false
        })
        widget.$root.$emit('sendMessage', message)
        console.log('message factory: platform ' + platformId + ': Cancel emergency surface')
      }
    },
    updateTransponderPosition: function (widget, platformId, latitude, longitude) {
      const accuracy = prompt('Enter accuracy:', '10.0')
      if (!isNaN(Number(accuracy)) && Number(accuracy) > 0) {
        const message = new ROSLIB.Message({
          requester: this.clientId,
          destination: platformId,
          sequence_id: this.getNewSequenceId(),
          type: BELUGA_COMMAND,
          payload: '{"command_id": 101, ' +
                    '"latitude_1": ' + latitude + ', ' + '"longitude_1": ' + longitude + ', ' +
                    '"floats": [' + accuracy + '], "ints": [2]}',
          priority: PRIO_USER,
          channel: CHANNEL_AUTO,
          is_reply: false
        })
        widget.$root.$emit('sendMessage', message)
        console.log('message factory: platform ' + platformId + ': Update manual position to ' + latitude + ', ' + longitude)
      }
    },
    setIntervals: function (widget, platformId, type) {
      // Switch command (monitoring / reporting)
      let cmdId = CMD_MONITORING_INTERVALS
      let cmdStr = 'monitoring'
      let defaultIntervals = ['5', '5', '2', '30', '2']
      if (type === INTERVALS_REPORTING) {
        cmdId = CMD_REPORTING_INTERVALS
        cmdStr = 'reporting'
        defaultIntervals = ['10', '10', '5', '300', '5']
      }

      // Read intervals from user input
      // TODO: Proper modal dialog
      const deck = prompt('Enter deck interval (sec):', defaultIntervals[0])
      const surface = prompt('Enter surface interval (sec):', defaultIntervals[1])
      const descent = prompt('Enter descent interval (sec):', defaultIntervals[2])
      const seafloor = prompt('Enter seafloor interval (sec):', defaultIntervals[3])
      const ascent = prompt('Enter ascent interval (sec):', defaultIntervals[4])

      if ((!isNaN(Number(deck)) && Number(deck) > 0) &&
        (!isNaN(Number(surface)) && Number(surface) > 0) &&
        (!isNaN(Number(descent)) && Number(descent) > 0) &&
        (!isNaN(Number(seafloor)) && Number(seafloor) > 0) &&
        (!isNaN(Number(ascent)) && Number(ascent) > 0)) {
        const message = new ROSLIB.Message({
          requester: this.clientId,
          destination: platformId,
          sequence_id: this.getNewSequenceId(),
          type: BELUGA_COMMAND,
          payload: '{"command_id": ' + cmdId + ', "ints": [' + deck + ', ' + surface + ', ' + descent + ', ' + seafloor + ', ' + ascent + ']}',
          priority: PRIO_USER,
          channel: CHANNEL_AUTO,
          is_reply: false
        })
        widget.$root.$emit('sendMessage', message)
        console.log('message factory: platform ' + platformId +
          ': Update intervals (' + cmdStr + ') to [' + deck + ', ' + surface + ', ' + descent + ', ' + seafloor + ', ' + ascent + ']')
      }
    }
  }
}
